import { Layout } from 'components/layout'
import { Container } from 'components/container'
import { IconWhatsapp } from 'components/icons/whatsapp'
import { IconTelegram } from 'components/icons/telegram'
import { IconEmail } from 'components/icons/email'
import { Header, Img, Link, Links, Subtitle, Title } from './styled'
import { useDataContext } from 'context/data-context'
import { parseMarkdown } from 'utils'

export const SendData = () => {
  const { translate } = useDataContext()

  return (
    <Layout>
      <Container>
        <Header>
          <Title>{translate('Send us more info title')}</Title>
          <Img
            src="https://gdb.rferl.org/01000000-0a00-0242-60d6-08dc95dfd633.png"
            alt={translate('Send us more info title')}
          />
          {parseMarkdown(translate('Description paragraph'))}
        </Header>

        <Subtitle>{translate('Do you have more info?')}</Subtitle>

        <Links>
          <Link href="" target="_blank" rel="noreferrer">
            <IconWhatsapp /> {translate('WhatsApp')}
          </Link>
          <Link href={translate('Telegram')} target="_blank">
            <IconTelegram /> {translate('Telegram')}
          </Link>
          <Link href={`mailto:${translate('Email')}`} target="_blank">
            <IconEmail /> {translate('Email')}
          </Link>
        </Links>
      </Container>
    </Layout>
  )
}
